export const VALIDATE_SCP_TOKEN = '/auth';
export const VALIDATE_SCP_TOKEN_V2 = '/auth2';
